import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Button, Link, Typography, TextField } from '@material-ui/core';
import ReactDataGrid from 'react-data-grid';

import { ModalManager } from 'react-dynamic-modal';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import Modal from 'react-modal';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import MaterialAutoComplete from './MaterialAutoComplete';
import MaterialSelect from './MaterialSelect';
import LpbFilters from './LpbFilters';
import BuyerCodeSelect from './BuyerCodeSelect';
import services from './../store/services';
import { adalApiFetch, authContext } from './../store/adalConfig';
import LPBRadioFilters from './LpbRadioFilters';
import CustomCellFormatter from './CustomCellFormatter';
import MaterialGrid from './MaterialGrid';

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: 5,
        paddingBottom: 10,
    },  
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    link: {
        margin: theme.spacing(1),
    },
    disabledLink: {
        margin: theme.spacing(1),
        color: theme.palette.action.disabledBackground,
        cursor: "not-allowed",
        opacity: 0.5
    },
    container: {
        alignItems: "center",
        display: "flex-grow",
    },
    item: {

    },
    hidden: {
        flexGrow: 1,
        paddingTop: 5,
        paddingBottom: 10,
        display: 'none',
    },
    overlay: {
        zIndex: 2
    },
    topLinkGrid: {
        paddingTop:12
    }
});

const modalFinaliseSaleStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: 340,
        height: 110,
        textAlign: 'center'
    }
};

const modalLotSearchStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        zIndex: 2
    }
};

const modalTransactionEventsStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-10%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        width: 640,
        zIndex: 3
    }
};

const columns = [
    {
        key: 'seller',
        name: 'Seller',
        editable: false,
    },
    {
        key: 'lotNo',
        name: 'Lot No',
        editable: false,
        width: 100,

    },
    {
        key: 'input',
        name: 'Input',
        editable: true,
        width: 300,
        formatter: (props) => {
            const style = { backgroundColor: 'white' };
            if (props.row.cannotSave) {
                style.backgroundColor = 'coral';
            }
            return <div style={style}>{props.value === null || props.value === '' || props.value === undefined ? '\u00A0' : props.value}</div>
        }
    },
    {
        key: 'price',
        name: 'Price',
        editable: false,
        width: 150,
    },
    {
        key: 'result',
        name: 'Result',
        editable: false,
        width: 100,
        formatter: <CustomCellFormatter/>
    },
    {
        key: 'buyer',
        name: 'Buyer',
        editable: false,
    }
];

const transactionEventsColumns = [    
    {
        key: 'transactionDate',
        name: 'Event Date',
        editable: false,
        width: 200      
    },
    {
        key: 'price',
        name: 'Price',
        editable: false,
        width: 80
    },
    {
        key: 'buyerName',
        name: 'Buyer',
        editable: false,
        width: 120
    },
    {
        key: 'saleOutcome',
        name: 'Outcome',
        editable: false,
        width: 80
    },
    {
        key: 'source',
        name: 'Source',
        editable: false,
        width: 90
    }
];

class LpbEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SaleIdSelectText: '',
            SaleIdSelectValue: '',
            SaleDisplayType: 0,  // Room1 = 100000000, Room2 = 100000001
            RoomNo: '',
            SellerSelectText: '',
            SellerSelectValue: '',
            BuyerSelectText: '',
            BuyerSelectValue: '',
            TransferSelectText: '',      
            ckMissing: false,
            ckPI: false,
            ckWD: false,
            ckNB: false,
            ckAWEX: true,
            rgSale: true,
            rgPrivate: false,
            rgTransfer: false,
            showModalFinalSale: false,
            showModalCompleteSale: false,
            showModalLotSearch: false,
            showModalTransactionEvents: false,
            modalLotSearchSellerSelectText: '',
            modalLotSearchSellerSelectValue: '',
            modalLotSearchLotNo: '',
            rows: [],
            selectedIndexes: [],
            BuyerCode: '',
            saleDisplayPath: '',
            editCellDetails: { row: -1, valid: true},
            testingCellX: -1,
            testingCellY: -1,
            hasAccess: false,
            gridParams: [],
            selectedEntry: '',
            hasSaleDateExpired: false,
            currentSelectedRowIndex: null,
            refresh : false
        };

        //set current user sale day id
        this.setCurrentSaleIdForUser();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.state.SaleIdSelectValue !== prevState.SaleIdSelectValue) {
            this.setDisplayType();
            this.checkDataLock();
        }

        let updatePath = false;
        if (this.state.SaleIdSelectValue !== prevState.SaleIdSelectValue ||
            this.state.SellerSelectText !== prevState.SellerSelectText ||
            this.state.BuyerSelectText !== prevState.BuyerSelectText ||
            this.state.RoomNo !== prevState.RoomNo ||
            this.state.ckAWEX !== prevState.ckAWEX ||
            (this.state.rgTransfer !== prevState.rgTransfer || this.state.rgSale !== prevState.rgSale || this.state.rgPrivate !== prevState.rgPrivate) ||
            this.state.ckMissing !== prevState.ckMissing || this.state.ckPI !== prevState.ckPI || this.state.ckWD !== prevState.ckWD || this.state.ckNB !== prevState.ckNB
        ) {
            updatePath = true;
            if (this.state.rgTransfer)
                this.getLotsForManualTransfer()
            else
                this.getLots();
        }
        if (updatePath || this.state.SaleDisplayType !== prevState.SaleDisplayType) {
            this.setPathForSaleDisplay();
        }
    }

    componentDidMount() {
        //check access
        if (!this.state.hasAccess) {
            services.checkAccess().then(response => {
                if (response.data) {
                    this.setState({ hasAccess: true });
                }
            });
        }
       
        Modal.setAppElement('body');
    }

    handleStateChange = (key, value) => {
        this.setState({ ...this.state, [key]: value });
        //console.log(this.state);

        //sale
        if (key === 'rgSale' && value === true) {
            this.setState({ ...this.state, rgTransfer: false, rgSale: true, rgPrivate: false }, () => this.getLots());
        }
        //private
        else if (key === 'rgPrivate' && value === true) {
            this.setState({ ...this.state, rgTransfer: false, rgSale: false, rgPrivate: true }, () => this.getLots());
        }
        //transfer
        else if (key === 'rgTransfer' && value === true) {
            this.setState({ ...this.state, rgTransfer: true, rgSale: false, rgPrivate: false }, () => this.getLotsForManualTransfer());
        }
        //buyer code
        else if (key === 'BuyerSelectText') {
            if (value === '')
                this.setState({ TransferSelectText: '' });
        }
    }
    
    handleSelectionChange = (nameKey, nameValue, idKey, idValue) => {
        this.setState({
            ...this.state,
            [nameKey]: nameValue,
            [idKey]: idValue,
            currentSelectedRowIndex: null
        });
    }

    addTransaction = (rowId, input, isPrivate) => {
        services.saveTransaction(`lotId=${encodeURI(rowId)}&transactionInput=${encodeURI(input)}&privatesale=${encodeURI(isPrivate)}`).then(response => {
            if (response.data && response.data.message) {
                let message = response.data.message;
                toast(`Error during saving: ${message} `, { autoClose: 5000, type: toast.TYPE.ERROR });
                const row = this.state.rows.find(q => q.lotOfferId === rowId);
                if (row) {
                    const newRows = this.state.rows.map(q => {
                        if (q === row) {
                            const newRow = { ...row};
                            newRow.cannotSave = true;
                            return newRow;
                        } else {
                            return q;
                        }
                    })
                    this.setState({
                        ...this.state,
                        rows: newRows
                    });
                }
                //this.getLots(); // because incorrect data disappear
            }
            else if (response.data.lotAfterSave) {

                const newRows = [...this.state.rows];
                const foundIndex = newRows.findIndex(q => q.lotOfferId === rowId);
                newRows[foundIndex] = response.data.lotAfterSave;
                this.setState({
                        ...this.state,
                        rows: newRows
                });
            }
        });
        const foundCurrentIndex = this.state.rows.findIndex(q => q.lotOfferId === rowId);
        const rowIdx = foundCurrentIndex + 1;
        if (rowIdx < this.state.rows.length) {
            const inputIdx = this.getInputIndex();
            if (rowIdx > -1 && inputIdx > -1) {
                this.grid.openCellEditor(rowIdx, inputIdx);
            }
        }
    }

    getLots = () => {

        var url = "api/lpb/GetLots?saleDayId=" + encodeURI(this.state.SaleIdSelectValue);
        if (this.state.RoomNo !== '') url = url + "&roomNo=" + encodeURI(this.state.RoomNo);
        if (this.state.SellerSelectText !== '') url = url + "&seller=" + encodeURI(this.state.SellerSelectText);
        if (this.state.BuyerSelectText !== '') url = url + "&buyer=" + encodeURI(this.state.BuyerSelectText);
        url = url + "&awexonly=" + encodeURI(this.state.ckAWEX);
        url = url + "&missing=" + encodeURI(this.state.ckMissing);

        //sales results
        url = url + this.getOutcomeFilters();
        /*
        if (this.state.ckPI === true || this.state.rgPrivate === true) url = url + "&outcome=PI";
        if (this.state.ckWD === true) url = url + "&outcome=WD";
        if (this.state.ckNB === true) url = url + "&outcome=NB";
        if (this.state.rgSale === true) url = url + "&outcome=S";
        */

        adalApiFetch(fetch, url)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    ...this.state,
                    rows: data
                });
            });
    }

    getLotsForManualTransfer = () => {

        var url = "api/lpb/GetLotsForTransfer?saleDayId=" + encodeURI(this.state.SaleIdSelectValue);
        if (this.state.RoomNo !== '') url = url + "&roomNo=" + encodeURI(this.state.RoomNo);
        if (this.state.SellerSelectText !== '') url = url + "&seller=" + encodeURI(this.state.SellerSelectText);
        if (this.state.BuyerSelectText !== '') url = url + "&buyer=" + encodeURI(this.state.BuyerSelectText);
        //if (this.state.TransferSelectText !== '') url = url + "&buyer=" + encodeURI(this.state.TransferSelectText);
        url = url + "&awexonly=" + encodeURI(this.state.ckAWEX);
        url = url + "&missing=" + encodeURI(this.state.ckMissing);

        //sales results
        url = url + this.getOutcomeFilters();

        /*
        if (this.state.ckPI === true || this.state.rgPrivate === true) url = url + "&outcome=PI";
        if (this.state.ckWD === true) url = url + "&outcome=WD";
        if (this.state.ckNB === true) url = url + "&outcome=NB";
        if (this.state.rgSale === true) url = url + "&outcome=S";
        */

        adalApiFetch(fetch, url)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    ...this.state,
                    rows: data
                });
            });
    }

    processLotsForManualTransfer = () => {
        //no buyer selected
        if (this.state.BuyerSelectText === '') {
            toast('No buyer code specified!', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        //no transfer to selected
        if (this.state.TransferSelectText === '') {
            toast('No transfer to code specified!', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        //no records selected
        if (this.state.selectedIndexes == null || this.state.selectedIndexes.length === 0) {
            toast('No records to transfer selected!', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        //get selected lot offers
        var selectedLots = [];
        var selectedInputs = [];
        for (let i = 0; i < this.state.selectedIndexes.length; i++) {
            var lotOfferId = this.state.rows[this.state.selectedIndexes[i]].lotOfferId;
            selectedLots[i] = lotOfferId;

            var input = this.state.rows[this.state.selectedIndexes[i]].input;
            selectedInputs[i] = input;
        }

        //no valid data selected
        if (selectedLots == null || selectedLots.length === 0) {
            toast('No records to transfer found!', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        //update selected lots
        services.processLotsForManualTransfer(`saleDayId=${encodeURI(this.state.SaleIdSelectValue)}&buyer=${encodeURI(this.state.BuyerSelectText)}&transferTo=${encodeURI(this.state.TransferSelectText)}&transactionInputs=${encodeURI(selectedInputs)}&lotOfferIds=${encodeURI(selectedLots)}`).then(response => {
            //error object exists
            if (response.data) {
                let _data = response.data;
                let _indexArr = [];
                let _previousIndex, i = 0;
                let _errorLots = 'Error when transferring lots:';

                if (_data.indexOf(',') > -1) {
                    for (i = 0; i < _data.length; i++) {
                        if (_data[i] === ',') {
                            let _separated = _data.slice(_previousIndex, i);
                            _indexArr.push(_separated);
                            _previousIndex = i + 1;
                        }
                    }
                    _indexArr.push(_data.slice(_previousIndex, i));

                    //find lotNo not updated
                    for (i = 0; i < _indexArr.length; i++) {
                        let _foundRow = this.state.rows.find(r => r.lotOfferId == _indexArr[i]);
                        if (_foundRow) {
                            _errorLots += _foundRow.lotNo + ((i === 0) ? ' ' : ',');
                        }
                    }
                }
                else {
                    _errorLots += _data;
                }

                toast(_errorLots, { autoClose: 3000, type: toast.TYPE.WARNING });
                this.getLotsForManualTransfer();

                //select rows not updated
                this.setState({ selectedIndexes: [] });
                //this.setState({ selectedIndexes: this.state.selectedIndexes.concat(this.state.rows.map(r => this.getRowIndex(r, _indexArr))) });
            }
            //no errors
            else {
                toast('Data has been sucessfully transferred!', { autoClose: 3000, type: toast.TYPE.SUCCESS });

                this.getLotsForManualTransfer();
                //this.getLots();
                this.setState({ selectedIndexes: [] });
            }
        });
    }

    getOutcomeFilters = () => {
        let outcome = "";
        if ((this.state.ckPI || this.state.rgPrivate) || this.state.ckWD || this.state.ckNB || this.state.rgSale) {
            if (this.state.ckPI) {
                outcome += "PI,";
            }
            if (this.state.ckWD) {
                outcome += "WD,";
            }
            if (this.state.ckNB) {
                outcome += "NB,";
            }
            //if (this.state.rgSale && outcome === "") {
            //    outcome += "S,TR";
            //}
            if (this.state.rgTransfer) {
                outcome += "TR";
            }

            //remove the last char if it's ","
            if (outcome !== "" && outcome.slice(-1) === ",") {
                outcome = outcome.substring(0, outcome.length - 1);
            }
            if (outcome !== "")
                outcome = "&outcome=" + outcome;
        }
        return outcome;
    }

    getRowIndex = (row, arr) => {
        for (let i = 0; i < arr.length; i++) {
            if (row.lotOfferId == arr[i]) {
                let _rowIndex = this.state.rows.findIndex(q => q.lotOfferId == arr[i]);
                return _rowIndex;
            }
        }
        return -1;
    }

    onRowsSelected = rows => {
        this.setState({
            selectedIndexes: this.state.selectedIndexes.concat(
                rows.map(r => r.rowIdx)
            )
        });
    };

    onRowsDeselected = rows => {
        let rowIndexes = rows.map(r => r.rowIdx);
        this.setState({
            selectedIndexes: this.state.selectedIndexes.filter(
                i => rowIndexes.indexOf(i) === -1
            )
        });
    };

    onCellSelected = (params) => {
        const { rowIdx, idx } = params;

        if(typeof params ==='number' ){
            this.setState({ currentSelectedRowIndex: params });
        }else{
            this.setState({ currentSelectedRowIndex: null });
        }

        //can edit data?
        if (this.state.hasSaleDateExpired) {
            toast('Data cannot be edited as the sale date is too old', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        const editCellDetails = this.state.editCellDetails;
        this.setState({
            testingCellX: rowIdx,
            testingCellY:  idx 
        });

        const inputIdx = this.getInputIndex();

        if (editCellDetails != null && editCellDetails.isValid === false) {
            this.grid.openCellEditor(editCellDetails.row, inputIdx);
        }
        else {
            this.setState({
                editCellDetails: { row: rowIdx, valid: true}
            });

            if (this.state.rows.length > 0 && idx !== inputIdx) {
                if (this.grid != null) {
                    this.grid.openCellEditor(rowIdx, inputIdx);
                }
                else {
                    let current = this;
                    setTimeout(() => {
                        if (current && current.grid) {
                            current.grid.openCellEditor(rowIdx + (current.state.rows.length - 1 === rowIdx?0:1), inputIdx);
                        }
                    }, 0);
                }
            }
        }
    }

    onGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        //can edit data?
        if (this.state.hasSaleDateExpired) {
            toast('Data cannot be edited as the sale date is too old', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        const lotOfferId = this.state.rows[fromRow].lotOfferId;
        let fromRowInput = this.state.rows[fromRow].input;
        if (fromRowInput === null) {
            fromRowInput = "";
        }
        if (fromRowInput !== updated.input) {
            this.addTransaction(lotOfferId, updated.input, this.state.rgPrivate);
            this.setState(state => {
                const rows = state.rows.slice();
                for (let i = fromRow; i <= toRow; i++) {
                    rows[i] = { ...rows[i], ...updated };
                }
                return { rows };
            });
            this.refresh();
        }       
    };

    onRowDoubleClick = rowNo => {
        this.setTransactionEventsModal(rowNo);
    };

    openBuyerSearchModal() {
        ModalManager.open(<BuyerCodeSelect onRequestClose={() => true} />);
    }
    
    setShowFinaliseSaleModal = (show) => {
        this.setState({ showModalFinalSale: show });
        //console.log(this.state);
    }

    closeFinaliseSaleModal = () => {
        this.setState({ showModalFinalSale: false });
        //console.log(this.state);
    }

    finaliseSaleAndCloseModal = () => {
        this.finaliseSale();
        this.setState({ showModalFinalSale: false });
        //console.log(this.state);
    }

    setShowCompleteSaleModal = (show, complete) => {
        if (!show && complete) {
            this.completeSale();
        }
        this.setState({ showModalCompleteSale: show });
    }

    completeSale = () => {
        if (this.state.SaleIdSelectValue === null || this.state.SaleIdSelectValue === '')
            return;

        //can edit data?
        if (this.state.hasSaleDateExpired) {
            toast('Data cannot be edited as the sale date is too old', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        var query = "saleDayId=" + encodeURI(this.state.SaleIdSelectValue);

        services.completeSale(query).then(response => {
            if (response.data) {
                // not sure but just in case
                if (this.state.rgTransfer)
                    this.getLotsForManualTransfer()
                else
                    this.getLots();
            }
        });
    }

    finaliseSale = () => {
        //this.setState({ ...this.state});
        //console.log(this.state);
        if (this.state.SaleIdSelectValue === null || this.state.SaleIdSelectValue === '')
            return;

        //can edit data?
        if (this.state.hasSaleDateExpired) {
            toast('Data cannot be edited as the sale date is too old', { autoClose: 3000, type: toast.TYPE.WARNING });
            return;
        }

        var query = "saleDayId=" + encodeURI(this.state.SaleIdSelectValue);
        if (this.state.RoomNo !== '') query += "&roomNo=" + encodeURI(this.state.RoomNo);
        if (this.state.SellerSelectText !== '') query += "&seller=" + encodeURI(this.state.SellerSelectText);
        if (this.state.BuyerSelectText !== '') query += "&buyer=" + encodeURI(this.state.BuyerSelectText);
        query += "&awexonly=" + encodeURI(this.state.ckAWEX);
        query += "&missing=" + encodeURI(this.state.ckMissing);

        //sales results
        query += this.getOutcomeFilters();

        /*
        if (this.state.ckPI === true || this.state.rgPrivate === true) query += "&outcome=PI";
        if (this.state.ckWD === true) query += "&outcome=WD";
        if (this.state.ckNB === true) query += "&outcome=NB";
        if (this.state.rgSale === true) query += "&outcome=S";
        */
       
        services.finaliseSale(query).then(response => {
            if (response.data) {
                //this.getLots();
                if (this.state.rgTransfer)
                    this.getLotsForManualTransfer()
                else
                    this.getLots();
            }
        });
    }

    setPathForSaleDisplay = () => {
        if (this.state.SaleIdSelectValue && this.state.SaleDisplayType) {
            //controller
            let saleDisplayPath = '/saleResultsDisplay'
            //build params path
            saleDisplayPath = `${saleDisplayPath}/${this.state.SaleIdSelectValue}/${this.state.ckAWEX}/${this.state.RoomNo ? (this.state.RoomNo) : ("-1")}/${this.state.SaleDisplayType ? (this.state.SaleDisplayType) : ("-1")}`;
            //add seller
            saleDisplayPath = `${saleDisplayPath}/${this.state.SellerSelectText ? this.state.SellerSelectText : ("-1")}`;
            //add buyer
            saleDisplayPath = `${saleDisplayPath}/${this.state.BuyerSelectText ? this.state.BuyerSelectText : ("-1")}`;
            //missing
            saleDisplayPath = `${saleDisplayPath}/${this.state.ckMissing ? true : false}`;
            //add sale results/outcomes
            saleDisplayPath = `${saleDisplayPath}/${this.state.ckWD ? "WD" : ("-1")}`;
            saleDisplayPath = `${saleDisplayPath}/${this.state.ckNB ? "NB" : ("-1")}`;
            saleDisplayPath = `${saleDisplayPath}/${this.state.rgSale ? "S" : ("-1")}`;
            saleDisplayPath = `${saleDisplayPath}/${this.state.rgTransfer ? "TR" : ("-1")}`;

            this.handleStateChange('saleDisplayPath', saleDisplayPath);
        }
        else {
            this.handleStateChange('saleDisplayPath', "");
        }
    }

    setDisplayType = () => {
        if (this.state.SaleIdSelectValue) {
            services.getSaleDisplayType(`saleDayId=${encodeURI(this.state.SaleIdSelectValue)}`).then(response => {
                if (response.data) {
                    this.handleStateChange('SaleDisplayType', response.data);
                }
            });
        }else {
            this.handleStateChange('SaleDisplayType', 0);
        }
    }

    openSaleDisplay = () => {
        if (this.state.saleDisplayPath) {
            window.open(window.location.origin + this.state.saleDisplayPath, '_blank', 'toolbar=no,width=1024,height=768, resizable,scrollbars,status');
        }
        return false;
    }

    openModalLotSearch = () => {
        this.setState({ modalLotSearchLotNo: '', modalLotSearchSellerSelectValue: '', modalLotSearchSellerSelectText: '', showModalLotSearch: true });
        const rows = this.state.rows;
        if (rows.length) {
            // this.state.selectedIndexes.length ???
            const currentSelectedRowIndex = this.state.currentSelectedRowIndex;
            const selectedIndex = currentSelectedRowIndex &&  rows.length > currentSelectedRowIndex ? currentSelectedRowIndex : 0;
            const rowForSeller = this.state.editCellDetails > 0 ? rows[this.state.editCellDetails.row] : rows[selectedIndex];
            this.setState({ modalLotSearchLotNo: '', showModalLotSearch: true, modalLotSearchSellerSelectValue: rowForSeller.sellerId, modalLotSearchSellerSelectText: rowForSeller.seller });
        }
    }

    goToCell = () => {
        if (!this.state.rows || !this.state.rows.length || !this.state.modalLotSearchLotNo) {
            this.setState({ showModalLotSearch: false });
            return;
        }
        const rowIdx = this.state.modalLotSearchSellerSelectValue ?
            this.state.rows.findIndex(q => q.lotNo === this.state.modalLotSearchLotNo && q.sellerId === this.state.modalLotSearchSellerSelectValue)
            : this.state.rows.findIndex(q => q.lotNo === this.state.modalLotSearchLotNo);
        const inputIdx = this.getInputIndex();
        if (rowIdx > -1 && inputIdx > -1) {
            //this.grid.selectCell({ inputIdx, rowIdx });
            this.grid.openCellEditor(rowIdx, inputIdx);
        }
        this.setState({ showModalLotSearch: false});
    }

    goToUnsold = () => {
        if (!this.state.rows || !this.state.rows.length)
            return;

        const rowIdx = this.state.rows.findIndex(q => !q.result);
        const inputIdx = this.getInputIndex();

        if (rowIdx > -1 && inputIdx > -1) {
            this.grid.openCellEditor(rowIdx, inputIdx);
            // looks like glitch (grid does not want to focus automatically, row below help)
            this.setState({ showModalLotSearch: !this.state.showModalLotSearch });
            this.setState({ showModalLotSearch: !this.state.showModalLotSearch });
        }
    }

    getInputIndex = () => {
        let found = columns.findIndex(q => q.key === "input");
        return found + (this.state.rgTransfer?1:0);
    }

    getCheckBoxState = () => {
        if (this.state.rgTransfer === null)
            return false;
        if (this.state.rgTransfer === true)
            return true;
        return false;
    }

    //check if data lock should be applied
    checkDataLock = () => {
        let url = "api/lpb/hasSaleDateExpired?";
        url += "saleId=&saleDate=&saleDayId=" + encodeURI(this.state.SaleIdSelectValue);
        services.hasSaleDateExpired(url).then(response => {
            if (response != null) {
                if (response.data)
                    this.setState({ hasSaleDateExpired: true });
            }
        });
    }

    openModalTransactionEvents = () => {
        if (this.state.rows === null)
            return;
        if (this.state.editCellDetails === null)
            return;

        var _rowNo = this.state.editCellDetails.row;        
        if (_rowNo == null)
            return;

        this.setTransactionEventsModal(_rowNo);
    }

    setTransactionEventsModal = (rowNo) => {
        const _lotOfferId = this.state.rows[rowNo].lotOfferId;
        if (_lotOfferId === null)
            return;

        const _lotNo = this.state.rows[rowNo].lotNo;
        var _dict = {};
        _dict["lotOfferId"] = _lotOfferId;

        this.setState({
            showModalTransactionEvents: true,
            gridParams: _dict,
            selectedEntry: _lotNo
        });
        //console.log(this.state);
    }

    //set the user's default saled day based on the region
    setCurrentSaleIdForUser = () => {
        let url = "api/lpb/getCurrentSaleIdForUser";
        services.getCurrentSaleIdForUser(url).then(response => {
            let _result = (response !== null ? response.data : null);
            if (_result) {
                let _value = response.data.value;//'E7F320B2-334C-E911-80F3-0050568B4C0B'
                let _label = response.data.label;//'M02/19 Thu'
                
                if (_value !== null && _label !== null) {
                    this.setState({
                        SaleIdSelectValue: _value,
                        SaleIdSelectText: _label,
                    });
                }
            }
        });
        return;
    }

    getSize = () => {
        let count = this.state.rows.length;

        if (this.state.refresh && count > 0) {
            count++; // hack for update data-grid
            /*
            this.setState({
                refresh: false
            });
            */
        }
        return count;
    }

    refresh() {
        this.setState({
            refresh: true
        });
              
        if (this.state.rgTransfer)
            this.getLotsForManualTransfer()
        else
            this.getLots();
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={`${classes.root} ReactDataGridOverride`}>
                <Paper className={classes.paper}>

                    <Grid container spacing={0}>
                        <Grid item xs={2}>
                            <MaterialAutoComplete
                                inputId='SaleIdSelect'
                                label='SaleId / Day *'
                                placeholder='Enter a SaleId / Day'
                                ajax='api/lpb/GetSaleDaySuggestions'
                                displayText={this.state.SaleIdSelectText}
                                handleChange={this.handleStateChange}
                                handleSelected={this.handleSelectionChange}
                                displayType='true'
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <MaterialSelect
                                label='Room No'
                                inputName='room_no'
                                inputId='RoomNo'
                                handleStateChange={this.handleStateChange}
                                value={this.state.RoomNo}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <MaterialAutoComplete
                                inputId='SellerSelect'
                                label='Seller'
                                placeholder='Filter by Seller'
                                ajax='api/lpb/GetSellerSuggestions'
                                displayText={this.state.SellerSelectText}
                                handleChange={this.handleStateChange}
                                handleSelected={this.handleSelectionChange}
                                displayType='true'
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <MaterialAutoComplete
                                inputId='BuyerSelect'
                                label='Buyer'
                                placeholder='Filter by Buyer'
                                ajax='api/lpb/GetBuyerSuggestions'
                                displayText={this.state.BuyerSelectText}
                                handleChange={this.handleStateChange}
                                handleSelected={this.handleSelectionChange}
                                displayType='true'
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant="contained" color="primary" className={classes.button} onClick={this.getLots}>
                                Select
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                        <Grid item xs={4}>
                            <LpbFilters
                                filters={this.state}
                                onFilterChange={this.handleStateChange} />
                        </Grid>

                        <Grid item xs={3} className={classes.topLinkGrid}>
                            <Typography>
                                <Link href='#' className={classes.link} onClick={() => this.openModalLotSearch()}>
                                    Go to Lot 
                            </Link>
                            </Typography>
                        </Grid>
                        <Grid item xs={3} className={classes.topLinkGrid}>

                            <Typography>
                                <Link href='#' className={classes.link} onClick={() => this.openBuyerSearchModal()}>
                                    Search Buyers
                            </Link>
                            </Typography>
                        </Grid>

                        <Grid item xs={2} className={classes.topLinkGrid}>
                            <Typography>
                                <Link href="#"
                                    onClick={this.openSaleDisplay}
                                    className={this.state.saleDisplayPath ? classes.link : classes.disabledLink}>
                                    Open Results Viewer
                            </Link>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                        <Grid item xs={4}>
                            <LPBRadioFilters
                                onFilterChange={this.handleStateChange} />
                        </Grid>
                        <Grid item xs={2}>
                            <MaterialAutoComplete
                                inputId='TransferSelect'
                                label='Transfer to'
                                placeholder='Filter by Transfer To'
                                ajax='api/lpb/GetTransferedBuyers'
                                displayText={this.state.TransferSelectText}
                                handleChange={this.handleStateChange}
                                handleSelected={this.handleSelectionChange}
                                displayType={(this.state.rgTransfer ? 'true' : 'false')}
                                extraValue={this.state.BuyerSelectText}
                            />                           
                        </Grid>
                        <Grid item xs={4}>
                            <Button variant="contained" color="primary" hidden={((this.state.rgTransfer === true && this.state.TransferSelectText !== '') ? false : true)} className={classes.button} onClick={this.processLotsForManualTransfer}>
                                Transfer
                            </Button>
                        </Grid>
                    </Grid>

                </Paper>

                {this.state.rgTransfer && (
                    <ReactDataGrid grid
                        rowKey="lotOfferId"
                        columns={columns}
                        rowGetter={i => this.state.rows[i]}
                        rowsCount={this.getSize()}//{this.state.rows.length}
                        rowHeight={34}
                        onGridRowsUpdated={this.onGridRowsUpdated}
                        //onCellSelected={this.onCellSelected}
                        onRowDoubleClick={this.onRowDoubleClick}
                        onRowClick={this.onCellSelected}
                        ref={grid => this.grid = grid}
                        enableCellSelect={true}
                        rowSelection={{
                            showCheckbox: true,
                            enableShiftSelect: true,
                            onRowsSelected: this.onRowsSelected,
                            onRowsDeselected: this.onRowsDeselected,
                            selectBy: {
                                indexes: this.state.selectedIndexes
                            }
                        }}
                    />
                )}

                {!this.state.rgTransfer && (
                    <ReactDataGrid grid
                        rowKey="lotOfferId"
                        columns={columns}
                        rowGetter={i => this.state.rows[i]}
                        rowsCount={this.getSize()} //{this.state.rows.length}
                        rowHeight={34}
                        onGridRowsUpdated={this.onGridRowsUpdated}
                        //onCellSelected={this.onCellSelected}                        
                        onRowDoubleClick={this.onRowDoubleClick}
                        onRowClick={this.onCellSelected}
                        ref={grid => this.grid = grid}
                        enableCellSelect={true}
                        rowSelection={{
                            showCheckbox: false,
                            enableShiftSelect: true,
                            onRowsSelected: this.onRowsSelected,
                            onRowsDeselected: this.onRowsDeselected,
                            selectBy: {
                                indexes: this.state.selectedIndexes
                            }
                        }}
                    />
                )}

                <KeyboardEventHandler handleFocusableElements={true} handleKeys={['ctrl+shift+f']} onKeyEvent={(key, e) => this.setShowFinaliseSaleModal(true)} />
                <KeyboardEventHandler handleFocusableElements={true} handleKeys={['ctrl+shift+s']} onKeyEvent={(key, e) => this.setShowCompleteSaleModal(true, false)} />
                <KeyboardEventHandler handleFocusableElements={true} handleKeys={['ctrl+shift+u']} onKeyEvent={(key, e) => this.goToUnsold()} />
                <KeyboardEventHandler handleFocusableElements={true} handleKeys={['ctrl+shift+l']} onKeyEvent={(key, e) => this.openModalLotSearch()} />
                <KeyboardEventHandler handleFocusableElements={true} handleKeys={['ctrl+shift+y']} onKeyEvent={(key, e) => this.openModalTransactionEvents()} />

                <Modal
                    isOpen={this.state.showModalFinalSale && (this.state.SaleIdSelectText != null && this.state.SaleIdSelectText !== '')}
                    onRequestClose={() => this.closeFinaliseSaleModal()}
                    contentLabel="Modal"
                    style={modalFinaliseSaleStyles}
                >
                    <div>Do you want to finalise sale {this.state.SaleIdSelectText}?</div>     
                    <Button variant="contained" color="primary" onClick={() => this.finaliseSaleAndCloseModal()}>Finalise Sale</Button>
                    <Button color="primary" onClick={() => this.closeFinaliseSaleModal()}>Close</Button>
                </Modal>

                <Modal
                    isOpen={this.state.showModalCompleteSale && (this.state.SaleIdSelectText != null && this.state.SaleIdSelectText !== '')}
                    onRequestClose={() => this.setShowCompleteSaleModal(false,false)}
                    contentLabel="Modal"
                    style={modalFinaliseSaleStyles}
                >
                    <div>Do you want to complete {this.state.SaleIdSelectText}?</div>
                    <Button variant="contained" color="primary" onClick={() => this.setShowCompleteSaleModal(false, true)}>Confirm</Button>
                    <Button color="primary" onClick={() => this.setShowCompleteSaleModal(false,false)}>Close</Button>
                </Modal>

                <Modal
                    isOpen={this.state.showModalLotSearch}
                    onRequestClose={() => this.setState({ showModalLotSearch: false })}
                    contentLabel="Modal"
                    style={modalLotSearchStyles}
                    overlayClassName={classes.overlay}
                >
                    <div>Go to lot </div>
                    <TextField value={this.state.modalLotSearchLotNo} 
                        onChange={(e) => this.setState({ modalLotSearchLotNo: e.target.value })} 
                        label="Lot No*" autoFocus={true}/>
                    <Grid>
                        <MaterialAutoComplete
                            inputId='modalLotSearchSellerSelect'
                            label='Seller*'
                            placeholder='Filter by Seller'
                            ajax='api/lpb/GetSellerSuggestions'
                            displayText={this.state.modalLotSearchSellerSelectText}
                            handleChange={this.handleStateChange}
                            handleSelected={this.handleSelectionChange}
                            displayType='true'
                        />
                    </Grid>
                    <Button variant="contained" color="primary" onClick={() => this.goToCell()}>Ok</Button>
                    <Button color="primary" onClick={() => this.setState({ showModalLotSearch: false })}>Cancel</Button>
                </Modal>

                <Modal
                    isOpen={this.state.showModalTransactionEvents}
                    onRequestClose={() => this.setState({ showModalTransactionEvents: false })}
                    contentLabel="Modal"
                    style={modalTransactionEventsStyles}
                    overlayClassName={classes.overlay}
                >
                    <MaterialGrid
                        gridColumns={transactionEventsColumns}
                        gridCaption={"Lot " + this.state.selectedEntry + " transaction events"}
                        gridAjax="api/lpb/GetTransactionEvents"
                        gridParams={this.state.gridParams}
                    />
                    <Button color="primary" onClick={() => this.setState({ showModalTransactionEvents: false })}>Close</Button>
                </Modal>

                <ToastContainer />
            </div>);
    }
}

export default withStyles(styles)(LpbEntry);

//<Grid container spacing={0}>
//    <Grid item xs={3}>
//        <span>Testing:</span>
//    </Grid>
//    <Grid item xs={3}>
//        <span>{'Cell Row Editing: ' + this.state.editCellDetails.row}</span>
//    </Grid>
//    <Grid item xs={3}>
//        <span>{'Cell Valid: ' + this.state.editCellDetails.valid}</span>
//    </Grid>
//    <Grid item xs={3}>
//        <span>{'Last Cell Selected: ' + this.state.testingCellX + ',' + this.state.testingCellY}</span>
//    </Grid>
//</Grid>s